/* ---------------------------------------------------------------------------
   wiseXPD wishlist, Polite Worldwide.

   WHAT IT DOES

   The heart writes the piece to this device at once (localStorage, the key the
   grid has always used). Everything Klaviyo-side happens after, in the
   background, and never delays or blocks the heart:

     known visitor     every save and remove sends Added to Wishlist /
                       Removed from Wishlist, with the piece and the whole
                       current list, so a flow can trigger and render it
     unknown visitor   the first save opens a small panel asking for an email.
                       Joining subscribes them to the polite community list
                       exactly the way the site opt-in does, then sends the
                       Added to Wishlist event for the piece they just saved.
                       "Not now" keeps the save, sends nothing, and the panel
                       does not ask again for 14 days.

   WHO IS "KNOWN"

     1. wx_email in localStorage: they joined through one of our forms
        (the site opt-in writes the same key). Events go to the public client
        events endpoint with that email.
     2. klaviyo.isIdentified() resolves true: Klaviyo's own cookie knows them,
        usually from clicking an email. Events go through klaviyo.track, which
        attaches them to that cookie's profile. We never see the email.
     3. Neither: nothing is sent to Klaviyo at all. The client events endpoint
        needs a profile on every event, and an anonymous one is a husk profile
        nobody can reach (wx-optin.js has the history: 118 in eight days).

   ADD-ONS

   Letters A-Z and Numbers 0-9 are the product page's customization add-on,
   never marketed. They can never be saved, are never sent, and are dropped
   from a stored list if one somehow holds them. Same for anything tagged
   _addon.

   TESTING

     ?wx_wishlist=reset   forget the panel's memory on this device (not the list)
     ?wx_wishlist=force   open the panel on the next save even if known
     ?wx_wishlist=off     never open the panel
     ?wx_test=1           marks the polite-metrics counts as a harness run

   NO SECRETS HERE. company_id is the public site id. No API key, ever.

   Source of truth: clients/polite-worldwide/landing-pages/ in the wisexpd repo.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.wxWishlist) return;

  var cfgEl = document.querySelector('[data-wx-wishlist-config]');
  if (!cfgEl) return;

  var cfg = {
    company: cfgEl.dataset.company || '',
    list: cfgEl.dataset.list || '',
    lp: cfgEl.dataset.lp || 'wishlist-v1',
    form: cfgEl.dataset.form || '',
    collect: cfgEl.dataset.collect || '',
    country: (cfgEl.dataset.country || '').toUpperCase(),
    page: cfgEl.dataset.page || '/pages/wishlist',
    shopAll: cfgEl.dataset.shopAll || '/collections/all',
    exclude: (cfgEl.dataset.exclude || 'letters-a-z,numbers-0-9')
      .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean),
    excludeTag: (cfgEl.dataset.excludeTag || '_addon').trim().toLowerCase()
  };

  var KEY = 'wx-polite-favs';
  var META = 'wx-polite-favs-meta';
  var K = 'https://a.klaviyo.com/client';
  var REV = '2025-07-15';
  var ASK_AGAIN_DAYS = 14;

  /* ---- memory ------------------------------------------------------------ */
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* fine */ } }
  function del(k) { try { localStorage.removeItem(k); } catch (e) { /* fine */ } }
  function days(k) {
    var t = Number(get(k) || 0);
    return t ? (Date.now() - t) / 86400000 : Infinity;
  }
  function anonId() {
    var a = get('wx_anon');
    if (!a) {
      a = 'wx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      set('wx_anon', a);
    }
    return a;
  }

  var urlMode = (location.search.match(/[?&]wx_wishlist=(off|reset|force)/) || [])[1];
  if (urlMode === 'reset') del('wx_wl_closed');

  function excluded(handle) { return cfg.exclude.indexOf(String(handle || '').toLowerCase()) > -1; }

  function read() {
    var raw;
    try { raw = JSON.parse(get(KEY) || '[]'); } catch (e) { raw = []; }
    if (!Array.isArray(raw)) raw = [];
    var clean = raw.filter(function (h, i) {
      return typeof h === 'string' && h && !excluded(h) && raw.indexOf(h) === i;
    });
    if (clean.length !== raw.length) set(KEY, JSON.stringify(clean));
    return clean;
  }
  function write(list) { set(KEY, JSON.stringify(list)); }

  function readMeta() {
    try { return JSON.parse(get(META) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeMeta(m) { set(META, JSON.stringify(m)); }

  /* ---- products ---------------------------------------------------------- */
  // /products/<handle>.js is Shopify's public product JSON, priced in the
  // visitor's own currency (cents). Fetched once per handle per page.
  var infoCache = {};
  function info(handle) {
    if (!infoCache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      infoCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('product ' + r.status);
        return r.json();
      });
    }
    return infoCache[handle];
  }

  function isAddon(p) {
    if (!p) return false;
    if (excluded(p.handle)) return true;
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    return !!cfg.excludeTag && tags.indexOf(cfg.excludeTag) > -1;
  }

  function abs(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.charAt(0) === '/') return location.origin + url;
    return url;
  }

  function sized(url, w) {
    if (!url) return '';
    return abs(url) + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // The theme's own money format, so a price here reads exactly as it does on
  // the grid. Intl is the fallback.
  function wxFmt(cents) {
    // As snippets/wx-money.liquid: the currency's own separators, one only from five figures,
    // decimals only when a price really has cents.
    var k = window.wxMoneyCfg || { pre: '$', post: '', th: ',', dec: '.' };
    if (!k.decoded) {
      var t = document.createElement('textarea');
      t.innerHTML = k.pre; k.pre = t.value;
      t.innerHTML = k.post; k.post = t.value;
      k.decoded = true;
    }
    var c = Math.round(Number(cents) || 0);
    var frac = k.dec ? c % 100 : 0;
    var whole = k.dec ? Math.floor(c / 100) : Math.round(c / 100);
    var s = String(whole);
    if (whole >= 10000) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, k.th);
    if (frac) s += k.dec + (frac < 10 ? '0' : '') + frac;
    return k.pre + s + k.post;
  }
  var money = wxFmt;

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  }

  function remember(p, variant) {
    var m = readMeta();
    m[p.handle] = {
      id: p.id,
      title: cardTitle(p.title),
      url: abs(p.url || ('/products/' + p.handle)),
      img: sized(p.featured_image, 800),
      price: (Number(p.price || 0) / 100),
      currency: currency(),
      variant: variant || ''
    };
    writeMeta(m);
    return m[p.handle];
  }

  /* ---- identity ---------------------------------------------------------- */
  // klaviyo.isIdentified() returns a Promise (wx-optin.js learned this the
  // hard way). The onsite script loads async, so it is polled briefly, and a
  // slow answer counts as "not known": asking a known subscriber once is a
  // smaller cost than never asking an unknown one.
  function klaviyoKnows(timeout) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(v) { if (!done) { done = true; resolve(v); } }
      setTimeout(function () { finish(false); }, timeout || 1500);
      (function poll(n) {
        if (done) return;
        var k = window.klaviyo;
        if (k && typeof k.isIdentified === 'function') {
          try {
            var v = k.isIdentified();
            if (v && typeof v.then === 'function') v.then(function (r) { finish(r === true); }, function () { finish(false); });
            else finish(v === true);
          } catch (e) { finish(false); }
          return;
        }
        if (n < 10) setTimeout(function () { poll(n + 1); }, 150);
      })(0);
    });
  }

  function whoAmI() {
    var email = get('wx_email');
    if (email) return Promise.resolve({ email: email });
    return klaviyoKnows(1500).then(function (k) { return k ? { klaviyo: true } : {}; });
  }

  /* ---- attribution (same fields the site opt-in records) ---------------- */
  var source = (function () {
    try {
      var q = new URLSearchParams(location.search);
      var out = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) {
        var v = q.get(k);
        if (v) out[k] = String(v).slice(0, 60);
      });
      if (q.get('fbclid')) out.paid_click = 'meta';
      if (q.get('gclid')) out.paid_click = 'google';
      if (!out.utm_source && !out.paid_click) out.utm_source = document.referrer ? 'referral' : 'direct';
      return out;
    } catch (e) { return {}; }
  })();

  /* ---- Klaviyo ----------------------------------------------------------- */
  // Our own counter for views and closes, exactly as the site opt-in does it:
  // a view is not a person, so it never goes to Klaviyo.
  function collect(event, props) {
    if (!cfg.collect) return;
    var body = Object.assign({
      event: event, form: cfg.form, lp: cfg.lp, visitor: anonId(), country: cfg.country,
      page: location.pathname,
      // Same rule as wx-optin.js: ?wx_test=1, headless Chrome, or an unpublished theme.
      test: /[?&]wx_test=1/.test(location.search) || /HeadlessChrome/.test(navigator.userAgent) ||
        !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || undefined
    }, source, props || {});
    try {
      fetch(cfg.collect, {
        method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).catch(function () { /* analytics never block a save */ });
    } catch (e) { /* nor break one */ }
  }

  // The same request the site opt-in sends, with the wishlist's own names, so
  // the list, the consent record and the welcome flow behave identically and
  // a flow can still tell where the person joined.
  function subscribe(email) {
    var profile = {
      type: 'profile',
      attributes: {
        email: email,
        anonymous_id: anonId(),
        properties: Object.assign({
          wx_source: 'wx-wishlist', wx_lp: cfg.lp, wx_form: cfg.form
        }, source.utm_source ? { wx_utm_source: source.utm_source } : {},
           source.utm_campaign ? { wx_utm_campaign: source.utm_campaign } : {},
           source.paid_click ? { wx_paid_click: source.paid_click } : {}),
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      }
    };
    return fetch(K + '/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: { profile: { data: profile } },
          relationships: { list: { data: { type: 'list', id: cfg.list } } }
        }
      })
    }).then(function (r) {
      if (r.status === 202) return { ok: true };
      return r.json().catch(function () { return {}; }).then(function (d) {
        var detail = d && d.errors && d.errors[0] && (d.errors[0].detail || d.errors[0].title);
        return { ok: false, message: detail || 'That did not go through. Try again in a moment.' };
      });
    });
  }

  // An event for a profile we have an email for.
  function postEvent(email, metric, props, uid) {
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                anonymous_id: anonId(),
              }
            }
          },
          time: new Date().toISOString(),
          unique_id: uid
        }
      }
    };
    // The current list on the profile too, so an email or a segment can read
    // it without an event in hand.
    if (props.Wishlist) {
      body.data.attributes.profile.data.attributes.properties = {
        wx_wishlist: props.Wishlist, wx_wishlist_count: props.WishlistCount
      };
    }
    return fetch(K + '/events/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify(body)
    }).catch(function () { /* a lost event never undoes a save */ });
  }

  function uidFor(metric, handle) {
    return 'wxwl-' + (metric.indexOf('Removed') === 0 ? 'rm' : 'add') + '-' + handle + '-' +
      Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
  }

  // Everything a flow needs to render the piece, plus the whole list. Property
  // names follow Klaviyo's own Viewed Product event (ProductName, ImageURL,
  // URL...) so the catalog-style blocks in the email editor recognise them.
  function eventProps(handle, meta, opts) {
    var list = read();
    var all = readMeta();
    return {
      ProductID: meta ? meta.id : '',
      ProductHandle: handle,
      ProductName: meta ? meta.title : '',
      VariantID: (opts && opts.variant) || (meta && meta.variant) || '',
      Price: meta ? meta.price : '',
      Currency: meta ? meta.currency : currency(),
      ImageURL: meta ? meta.img : '',
      URL: meta ? meta.url : location.origin + '/products/' + handle,
      Source: (opts && opts.source) || '',
      Wishlist: list,
      WishlistCount: list.length,
      // The newest twelve, with what an email needs to draw them. Handles alone
      // cannot be rendered in a Klaviyo template.
      WishlistItems: list.slice(-12).reverse().map(function (h) {
        var m = all[h] || {};
        return {
          handle: h, title: m.title || '', url: m.url || (location.origin + '/products/' + h),
          image: m.img || '', price: m.price === undefined ? '' : m.price, currency: m.currency || ''
        };
      }),
      page: location.pathname,
      lp: cfg.lp,
      form: cfg.form
    };
  }

  // Pieces saved before this script existed, or on a page that never fetched
  // them, have no cached details, and an email cannot draw a bare handle. The
  // newest twelve are looked up before an event goes out. Only for a known
  // visitor, so an anonymous browse never pays for it.
  function fill() {
    var all = readMeta();
    var missing = read().slice(-12).filter(function (h) { return !all[h]; });
    return Promise.all(missing.map(function (h) {
      return info(h).then(function (p) {
        if (!isAddon(p) && read().indexOf(h) > -1) remember(p, '');
      }, function () { /* gone from the store */ });
    }));
  }

  function sendEvent(who, added, handle, meta, opts) {
    if (!who.email && !who.klaviyo) return Promise.resolve();
    return fill().then(function () { return sendNow(who, added, handle, meta, opts); });
  }

  function sendNow(who, added, handle, meta, opts) {
    var metric = added ? 'Added to Wishlist' : 'Removed from Wishlist';
    var props = eventProps(handle, meta, opts);
    if (who.email) return postEvent(who.email, metric, props, uidFor(metric, handle));
    if (who.klaviyo && window.klaviyo) {
      try {
        if (typeof klaviyo.track === 'function') klaviyo.track(metric, props);
        else klaviyo.push(['track', metric, props]);
      } catch (e) { /* fine */ }
    }
    return Promise.resolve();
  }

  /* ---- change ------------------------------------------------------------ */
  function emit(handle, added) {
    try {
      document.dispatchEvent(new CustomEvent('wx:wishlist', {
        detail: { handle: handle, added: added, list: read() }
      }));
    } catch (e) { /* old browser: the hearts repaint on the next page */ }
    paint();
  }

  // Synchronous: the heart answers in the same frame. Returns the new state.
  function toggle(handle, opts) {
    if (!handle || excluded(handle)) return false;
    var list = read();
    var i = list.indexOf(handle);
    var added = i === -1;
    if (added) list.push(handle); else list.splice(i, 1);
    write(list);
    emit(handle, added);
    after(handle, added, opts || {});
    return added;
  }

  function remove(handle, opts) {
    if (read().indexOf(handle) === -1) return false;
    toggle(handle, opts);
    return true;
  }

  function after(handle, added, opts) {
    var metaP = info(handle).then(function (p) {
      if (isAddon(p)) {
        // Never savable. Undo quietly and send nothing.
        var l = read().filter(function (h) { return h !== handle; });
        write(l); emit(handle, false);
        throw new Error('addon');
      }
      return added ? remember(p, opts.variant) : (readMeta()[handle] || remember(p, ''));
    }, function () { return readMeta()[handle] || null; });

    Promise.all([metaP, whoAmI()]).then(function (r) {
      var meta = r[0], who = r[1];
      if (!added) {
        // Drop the cached details only after the event has read them.
        return sendEvent(who, false, handle, meta, opts).then(function () {
          if (read().indexOf(handle) === -1) {
            var m = readMeta(); delete m[handle]; writeMeta(m);
          }
        });
      }
      if (urlMode === 'force' || (!who.email && !who.klaviyo)) {
        if (shouldAsk()) { openPanel(handle, meta, opts); return; }
        if (urlMode !== 'force') return;
      }
      return sendEvent(who, true, handle, meta, opts);
    }).catch(function () { /* an add-on, or a failed lookup: the save stands */ });
  }

  function shouldAsk() {
    if (urlMode === 'off') return false;
    if (urlMode === 'force') return true;
    if (get('wx_email')) return false;
    return days('wx_wl_closed') >= ASK_AGAIN_DAYS;
  }

  /* ---- the panel --------------------------------------------------------- */
  var panel = null, pending = null, lastFocus = null;

  function buildPanel() {
    if (panel) return panel;
    var tpl = document.querySelector('template[data-wx-wl-panel]');
    if (!tpl) return null;
    var frag = tpl.content.cloneNode(true);
    panel = frag.querySelector('.wxwl-panel');
    document.body.appendChild(frag);

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-wxwl-close]')) { e.preventDefault(); closePanel(false); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) closePanel(false);
    });

    var form = panel.querySelector('[data-wxwl-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type=email]');
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { say('That email does not look right.'); input.focus(); return; }
      var btn = form.querySelector('button');
      btn.disabled = true; say('');
      subscribe(email).then(function (res) {
        btn.disabled = false;
        if (!res.ok) { say(res.message); return; }
        set('wx_email', email);
        // They are on the list now, so the site opt-in stops asking them too.
        set('wx_optin_joined', String(Date.now()));
        // Klaviyo's onsite script learns who this is, so what they browse next
        // lands on their profile rather than on an anonymous visitor.
        try {
          if (window.klaviyo && typeof klaviyo.identify === 'function') klaviyo.identify({ email: email });
          else if (window.klaviyo) klaviyo.push(['identify', { email: email }]);
        } catch (e2) { /* fine */ }
        var eid = 'wx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        postEvent(email, 'wx_form_submitted', {
          page: location.pathname, lp: cfg.lp, form: cfg.form, step: 1, surface: 'wishlist', event_id: eid
        }, eid);
        collect('submitted', { step: 1 });
        // The save that opened the panel, now that there is someone to send it to.
        if (pending && read().indexOf(pending.handle) > -1) {
          sendEvent({ email: email }, true, pending.handle, pending.meta, pending.opts);
        }
        pending = null;
        var em = panel.querySelector('[data-wxwl-email]');
        if (em) em.textContent = email;
        step('done');
        paint();
      }).catch(function () {
        btn.disabled = false;
        say('That did not go through. Try again in a moment.');
      });
    });
    return panel;
  }

  function say(text) {
    var m = panel && panel.querySelector('[data-wxwl-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }

  function step(name) {
    panel.querySelectorAll('[data-wxwl-step]').forEach(function (s) { s.hidden = s.dataset.wxwlStep !== name; });
    var f = panel.querySelector('[data-wxwl-step="' + name + '"] input, [data-wxwl-step="' + name + '"] a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }

  function openPanel(handle, meta, opts) {
    if (!buildPanel()) return;
    pending = handle ? { handle: handle, meta: meta, opts: opts || {} } : null;
    var piece = panel.querySelector('[data-wxwl-piece]');
    if (meta && meta.title) {
      panel.querySelector('[data-wxwl-title]').textContent = meta.title;
      var th = panel.querySelector('[data-wxwl-thumb]');
      if (meta.img) { th.src = meta.img.replace(/width=\d+/, 'width=160'); th.hidden = false; } else th.hidden = true;
      piece.hidden = false;
    } else {
      piece.hidden = true;
    }
    say('');
    if (panel.hidden) {
      lastFocus = document.activeElement;
      panel.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-open'); }); });
      collect('viewed');
    }
    step('ask');
  }

  function closePanel(silent) {
    if (!panel || panel.hidden) return;
    var wasAsking = !panel.querySelector('[data-wxwl-step="ask"]').hidden;
    panel.classList.remove('is-open');
    setTimeout(function () { panel.hidden = true; }, 240);
    if (wasAsking && !silent) {
      set('wx_wl_closed', String(Date.now()));
      collect('closed');
    }
    pending = null;
    if (lastFocus && typeof lastFocus.focus === 'function') { try { lastFocus.focus(); } catch (e) { /* fine */ } }
  }

  /* ---- product page heart ------------------------------------------------ */
  function variantFor(btn) {
    var form = btn.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return input.value;
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : '';
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wx-save]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wxSave) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = b.querySelector('[data-wx-save-label]');
      if (lbl) lbl.textContent = on ? (b.dataset.on || 'Saved') : (b.dataset.off || 'Save');
    });
    document.querySelectorAll('[data-wx-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.wxFav) > -1 ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wx-wl-count]').forEach(function (el) {
      el.textContent = list.length ? String(list.length) : '';
      el.hidden = !list.length;
    });
    document.querySelectorAll('[data-wx-wl-known]').forEach(function (el) {
      // Only for someone with something to keep and no email on file.
      el.hidden = !!get('wx_email') || !list.length;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wx-save]');
    if (b) {
      e.preventDefault();
      toggle(b.dataset.wxSave, { source: b.dataset.source || 'pdp', variant: variantFor(b) });
      return;
    }
    if (e.target.closest('[data-wx-wl-ask]')) {
      e.preventDefault();
      openPanel(null, null, { source: 'wishlist-page' });
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  /* ---- the wishlist page -------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // The grid's casing rule: a title typed entirely in capitals is set in
  // sentence case, a mixed-case one is the merchant's and is kept.
  function cardTitle(t) {
    t = String(t || '');
    if (t === t.toUpperCase() && t !== t.toLowerCase()) {
      var d = t.toLowerCase();
      return d.charAt(0).toUpperCase() + d.slice(1);
    }
    return t;
  }

  function cardSpec(p) {
    var spec = p.type || '';
    (p.options || []).some(function (o) {
      var n = String(o.name || '').toLowerCase();
      if (n.indexOf('size') === -1 && n.indexOf('length') === -1) return false;
      var v = o.values || [];
      if (!v.length) return true;
      function tidy(x) {
        x = String(x);
        if (x === x.toUpperCase() && x.indexOf('INCH') > -1) { x = x.toLowerCase(); x = x.charAt(0).toUpperCase() + x.slice(1); }
        return x;
      }
      var s = v.length > 1 ? tidy(v[0]) + ' to ' + tidy(v[v.length - 1]) : tidy(v[0]);
      spec = spec ? spec + ', ' + s : s;
      return true;
    });
    return spec.replace(/INCHES/g, 'inches').replace(/INCH/g, 'inch').replace(/Inches/g, 'inches').replace(/Inch/g, 'inch');
  }

  function cardHTML(p) {
    var title = cardTitle(p.title);
    var imgs = p.images || [];
    var swap = imgs.length > 1;
    var price = p.available
      ? (p.price_varies ? 'From ' : '') + esc(money(p.price))
      : '<span class="wxc-card__sold">Sold out</span>';
    var spec = cardSpec(p);
    return '' +
      '<div class="wxc-card">' +
        '<div class="wxc-card__media' + (swap ? ' wxc-card__media--swap' : '') + '">' +
          (p.featured_image ? '<img class="wxc-card__img" src="' + esc(sized(p.featured_image, 500)) + '" alt="' + esc(title) + '" loading="lazy">' : '') +
          (swap ? '<img class="wxc-card__img wxc-card__img--alt" src="' + esc(sized(imgs[1], 500)) + '" alt="" aria-hidden="true" loading="lazy">' : '') +
        '</div>' +
        '<div class="wxc-card__body">' +
          '<h2 class="wxc-card__name">' + esc(title) + '</h2>' +
          (spec ? '<p class="wxc-card__spec">' + esc(spec) + '</p>' : '') +
          '<p class="wxc-card__price">' + price + '</p>' +
          '<button class="wxwl-remove" type="button" data-wx-wl-remove="' + esc(p.handle) + '">Remove</button>' +
        '</div>' +
        '<button class="wxc-card__fav" type="button" data-wx-wl-remove="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remove ' + esc(title) + ' from your wishlist">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.8 15.1 3.8 9.6a4.6 4.6 0 0 1 8.2-2.8 4.6 4.6 0 0 1 8.2 2.8c0 5.5-8.2 10.9-8.2 10.9z"/></svg>' +
        '</button>' +
        '<a class="wxc-card__link" href="' + esc(p.url || ('/products/' + p.handle)) + '" aria-label="' + esc(title) + '"></a>' +
      '</div>';
  }

  function wishlistPage() {
    var host = document.querySelector('[data-wx-wl-page]');
    if (!host) return;
    var grid = host.querySelector('[data-wx-wl-grid]');
    var empty = host.querySelector('[data-wx-wl-empty]');
    var tally = host.querySelector('[data-wx-wl-tally]');

    function count() {
      var n = grid.querySelectorAll('[data-wx-card]').length;
      if (tally) tally.textContent = n ? n + (n === 1 ? ' piece' : ' pieces') : '';
      if (empty) empty.hidden = n > 0;
      grid.hidden = n === 0;
      // The empty state carries its own shop link; one is enough.
      var more = host.querySelector('.wxwl-page__more');
      if (more) more.hidden = n === 0;
      paint();
    }

    function draw() {
      var list = read().slice().reverse();   // newest first
      grid.textContent = '';
      if (!list.length) { count(); host.classList.add('is-ready'); return; }
      var cells = list.map(function (h) {
        var cell = document.createElement('div');
        cell.className = 'wxc__cell wxc__cell--product';
        cell.setAttribute('data-wx-card', '');
        cell.dataset.handle = h;
        cell.hidden = true;
        grid.appendChild(cell);
        return cell;
      });
      Promise.all(list.map(function (h, i) {
        return info(h).then(function (p) {
          if (isAddon(p)) { cells[i].remove(); remove(h, { source: 'wishlist-page' }); return; }
          if (!readMeta()[h]) remember(p, '');
          cells[i].innerHTML = cardHTML(p);
          cells[i].hidden = false;
        }, function () {
          // Gone from the store (deleted or unpublished): nothing to show.
          cells[i].remove();
        });
      })).then(function () { count(); host.classList.add('is-ready'); });
    }

    host.addEventListener('click', function (e) {
      var r = e.target.closest('[data-wx-wl-remove]');
      if (!r) return;
      e.preventDefault();
      var h = r.dataset.wxWlRemove;
      remove(h, { source: 'wishlist-page' });
      var cell = r.closest('[data-wx-card]');
      if (cell) cell.remove();
      count();
    });

    // A save or remove in another tab redraws the page.
    window.addEventListener('storage', function (e) { if (e.key === KEY) draw(); });

    draw();
  }

  /* ---- saved for later: the cart drawer and the cart page ---------------- */
  // A placeholder, [data-wx-cart-saved], sits under the line items: one in the
  // stock cart drawer (sections/cart-drawer.liquid, outside <cart-items>, so
  // the theme's re-render, which only rewrites that element's innerHTML, never
  // touches it) and one in the cart page's trust section, which this script
  // moves to just under the page's <cart-items>.
  //
  // It is filled with up to three saved pieces that are not already in the
  // bag, newest first, under the heading "Your wishlist". Sold-out pieces are skipped here (a dead row next to
  // the checkout is noise); they stay on the wishlist page and count in (n).
  // "Add to bag" only when the piece has a single variant and it is
  // available: on a necklace with lengths, picking the one length left would
  // choose a size for the customer, so that gets "Choose".
  //
  // Refilled on the theme's own events: theme:cart:change (end of every cart
  // rebuild, drawer and cart page), theme:cart-drawer:open, and any wishlist
  // change. Nothing is fetched on a plain page load unless the cart page is
  // open; the drawer pays for its lookups when it opens.
  var CART_MAX = 3;
  var cartCopy = {
    heading: cfgEl.dataset.cartHeading || 'Your wishlist',
    add: cfgEl.dataset.cartAdd || 'Add to bag',
    adding: cfgEl.dataset.cartAdding || 'Adding',
    choose: cfgEl.dataset.cartChoose || 'Choose',
    link: cfgEl.dataset.cartLink || 'View all',
    error: cfgEl.dataset.cartError || 'That did not go through. Try again in a moment.'
  };
  var cartSeq = 0, cartTimer = null;

  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function cartHosts() { return Array.prototype.slice.call(document.querySelectorAll('[data-wx-cart-saved]')); }

  // The cart page: under the page's own line items, not after the whole form.
  function placeOnCartPage() {
    var host = document.querySelector('[data-wx-cart-saved="page"]');
    var items = document.querySelector('.cart__form .cart__content cart-items, .cart__form cart-items');
    if (host && items && items.nextElementSibling !== host) items.insertAdjacentElement('afterend', host);
  }

  function inCart() {
    return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (c) { return (c.items || []).map(function (i) { return i.handle; }); });
  }

  function clearHost(h) { h.hidden = true; h.textContent = ''; }

  function variantLabel(p, v) {
    if (!v || (p.variants || []).length < 2) return '';
    var t = String(v.title || '');
    if (!t || /^default title$/i.test(t)) return '';
    return t.replace(/Inches\s+Inches/gi, 'inches').replace(/\bInches\b/gi, 'inches').replace(/\bInch\b/gi, 'inch');
  }

  function savedRow(p) {
    var title = cardTitle(p.title);
    var url = p.url || ('/products/' + p.handle);
    var avail = (p.variants || []).filter(function (v) { return v.available; });
    var single = (p.variants || []).length === 1 && avail.length === 1;
    var price = (p.price_varies && !single ? 'From ' : '') + money(single ? avail[0].price : p.price);
    var action = single
      ? '<button class="wxwl-cart__act" type="button" data-wx-cart-add="' + esc(avail[0].id) + '" data-handle="' + esc(p.handle) + '">' + esc(cartCopy.add) + '</button>'
      : '<a class="wxwl-cart__act" href="' + esc(url) + '">' + esc(cartCopy.choose) + '<span class="wxwl-hidden"> ' + esc(title) + '</span></a>';
    return '' +
      '<li class="wxwl-cart__row">' +
        '<a class="wxwl-cart__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 160)) + '" alt="" loading="lazy" width="56" height="56">' : '') +
        '</a>' +
        '<div class="wxwl-cart__body">' +
          '<a class="wxwl-cart__name" href="' + esc(url) + '">' + esc(title) + '</a>' +
          '<span class="wxwl-cart__price">' + esc(price) + '</span>' +
        '</div>' +
        action +
      '</li>';
  }

  // The heading row carries the count: YOUR WISHLIST on the left, "View all
  // (n)" on the right. When every saved piece is already in the bag (or sold
  // out) the row stands alone, so the wishlist is still one tap away.
  function drawSaved(host, picks, total) {
    if (!total) { clearHost(host); return; }
    host.innerHTML = '' +
      '<div class="wxwl-cart' + (picks.length ? '' : ' wxwl-cart--bare') + '">' +
        '<div class="wxwl-cart__head">' +
          '<p class="wxwl-cart__h">' + esc(cartCopy.heading) + '</p>' +
          '<a class="wxwl-cart__all" href="' + esc(cfg.page) + '">' + esc(cartCopy.link) + ' (' + total + ')</a>' +
        '</div>' +
        (picks.length ? '<ul class="wxwl-cart__list">' + picks.map(savedRow).join('') + '</ul>' : '') +
        '<p class="wxwl-cart__msg" role="status" hidden></p>' +
      '</div>';
    host.hidden = false;
  }

  function fillCart() {
    var hosts = cartHosts();
    if (!hosts.length) return;
    placeOnCartPage();
    var list = read();
    if (!list.length) { hosts.forEach(clearHost); return; }
    var seq = ++cartSeq;
    inCart().then(function (handles) {
      var cand = list.slice().reverse().filter(function (h) { return handles.indexOf(h) === -1; }).slice(0, 8);
      return Promise.all(cand.map(function (h) { return info(h).then(function (p) { return p; }, function () { return null; }); }));
    }).then(function (ps) {
      if (seq !== cartSeq) return;   // a newer fill is on its way
      var picks = ps.filter(function (p) { return p && !isAddon(p) && p.available; }).slice(0, CART_MAX);
      var total = read().length;
      cartHosts().forEach(function (h) { drawSaved(h, picks, total); });
    }).catch(function () { /* no cart answer: leave the block as it was */ });
  }

  function refillCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(fillCart, 60);
  }

  // The theme's own cart hand-off, the same one wx-pdp.js and wx-lp.js use.
  function rebuildCart() {
    var items = document.querySelector('cart-drawer cart-items') || document.querySelector('cart-items');
    if (items && typeof items.getCart === 'function') { items.getCart(); return true; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); return true; }
    return false;
  }

  function addSaved(btn) {
    var host = btn.closest('[data-wx-cart-saved]');
    var msg = host && host.querySelector('.wxwl-cart__msg');
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    btn.disabled = true;
    btn.textContent = cartCopy.adding;
    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.wxCartAdd), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || cartCopy.error);
        // The theme rebuilds the bag, fires theme:cart:change, and that refills
        // this block without the piece now in the bag.
        if (!rebuildCart()) window.location.href = shopRoot() + 'cart';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = cartCopy.add;
        if (msg) { msg.textContent = (err && err.message) || cartCopy.error; msg.hidden = false; }
      });
  }

  function cartSaved() {
    if (!cartHosts().length) return;
    placeOnCartPage();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wx-cart-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      addSaved(b);
    });
    document.addEventListener('theme:cart:change', refillCart);
    document.addEventListener('theme:cart-drawer:open', refillCart);
    document.addEventListener('wx:wishlist', refillCart);
    document.addEventListener('shopify:section:load', refillCart);
    window.addEventListener('storage', function (e) { if (e.key === KEY) refillCart(); });
    // The cart page shows the block at once; the drawer waits until it opens.
    var onPage = document.querySelector('[data-wx-cart-saved="page"]');
    if (onPage) fillCart();
    else if (!read().length) cartHosts().forEach(clearHost);
    else {
      var open = document.querySelector('cart-drawer.is-open, cart-drawer[open]');
      if (open) fillCart();
    }
  }

  /* ---- go ---------------------------------------------------------------- */
  window.wxWishlist = {
    list: read,
    has: function (h) { return read().indexOf(h) > -1; },
    toggle: toggle,
    remove: remove,
    ask: function () { openPanel(null, null, {}); },
    money: money
  };

  function boot() { paint(); wishlistPage(); cartSaved(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
